window.theme = window.theme || {};

  var cartItems ='';
 
(function($){
  var $ = jQuery = $;
  
  $(function() {  
    new theme.ShowSummary();
    $(document).ready(function(){
      theme.genie.getCart().then(function(cart){
        var hotPizzaStatus = theme.genie.checkForHotPizza(cart);
        if(hotPizzaStatus == 1){
          $(".qv-add-button").attr("disabled","disabled");
        }
      });
    });
    $('body').on('click', '.close', function() {
       $('#quick-view').hide();
    });
    var modal = document.getElementById("quick-view");
    window.onclick = function(event) {
      if (event.target == modal) {
        modal.style.display = "none";
      }
    }
    
    $('body').on('click', '.quick-view', function(e) {
      e.preventDefault();
      var $btn = $(this);
      var product_handle = $btn.data('handle');

      $.LoadingOverlay("show");

      theme.genie.getCart().then(function(cart) {
        var hotPizzaStatus = theme.genie.checkForHotPizza(cart);
        if (hotPizzaStatus == 1) {
          $.LoadingOverlay("hide");
          $btn.notify('Sorry, You can not add pizza bundle', { position: "top center", className: "error" });
          return;
        }

        var pizza_count = theme.genie.getPizzaCount(cart, $('#container').data('handle'));
        var total_count = $('#container').data('count');

        if (parseInt(pizza_count) >= parseInt(total_count)) {
          $.LoadingOverlay("hide");
          $btn.notify('Sorry, You can not add more pizza', { position: "top center", className: "error" });
          return;
        }

        theme.genie.getProductDetail('/products/' + product_handle + '.js').then(function(product) {
          var defaultVariantId = product.variants[0].id;
          var _setId = Date.now();

          var mainProperties = {
            Box: $('#container').data('handle'),
            _setId: _setId,
            type: 'Cold Pizza',
            extra_toppings: '',
            no_toppings: '',
            toppings: ''
          };

          var cartItems = [{
            quantity: 1,
            id: defaultVariantId,
            properties: mainProperties
          }];

          theme.genie.addItemsToCart({ items: cartItems })
            .then(function() {
              new theme.ShowSummary();
            })
            .fail(function(XMLHttpRequest) {
              $btn.notify(XMLHttpRequest.responseJSON.description, { position: "top center", className: "error" });
            })
            .always(function() {
              $.LoadingOverlay("hide");
            });
        });
      });
    });

     
    $(document).on("click",".checkout_btn",function(){
      $.LoadingOverlay("show");

      theme.genie.getCart().then(function(cart){
        var pizza_count = theme.genie.getPizzaCount(cart,$('#container').data('handle'));
        var total_count = $('#container').data('count');
        if(parseInt(pizza_count) < parseInt(total_count) ){
          $.LoadingOverlay("hide");
          $('.checkout_btn').notify('Sorry, You must add 4 pizza to continue',{ position:"top center", className: "error" } );
          return;
        }else{
         window.location.href="/cart";
        }
      });
    });
    $(document).on("click", ".qv-add-button", function () {
          $.LoadingOverlay("show");
      
          theme.genie.getCart().then(function(cart){
                var hotPizzaStatus = theme.genie.checkForHotPizza(cart);
                if(hotPizzaStatus == 1){
                  $.LoadingOverlay("hide");
                  $('.qv-add-button').notify('Sorry, You can not add pizza bundle',{ position:"top center", className: "error" } );
                  return;
                }
              var pizza_count = theme.genie.getPizzaCount(cart,$('#container').data('handle'));
                var total_count = $('#container').data('count');
                if(parseInt(pizza_count) >= parseInt(total_count) ){
                  $.LoadingOverlay("hide");
                  $('.qv-add-button').notify('Sorry, You can not add more pizza',{ position:"top center", className: "error" } );
                  return;
                }
                var cartItems = [];

                //var var_id = $('#quick-view select option:selected').val();
                var var_id = $('#quick-view input[name="pizza_dough"]:checked').val();
                var _setId = Date.now();
                var mainProperties = new Object();
              
                var extra_toppings = [];
                var standard_toppings = [];
                  var small_toppings_title = [];
                $(".toppings_checkbox:checked").each(function(){
                   extra_toppings.push($(this).data('title'));
                   small_toppings_title.push($(this).data('small-title'));
                });
                $(".standard_topping_radio:not(:checked)").each(function(){
                   standard_toppings.push($(this).val());
                 });
              
                mainProperties.Box = $('#container').data('handle');
                mainProperties._setId = _setId;
                mainProperties.type = 'Cold Pizza';
                mainProperties.extra_toppings = extra_toppings.join(',');
                mainProperties.no_toppings = standard_toppings.join(',');
                mainProperties.toppings = small_toppings_title.join(',');
                var cartItem = new Object();
                cartItem.quantity =  1;
                cartItem.id = var_id;
                cartItem.properties = mainProperties;
                cartItems.push(cartItem);


                $(".toppings_checkbox:checked").each(function(){
                    var mainProperties = new Object();
                    mainProperties.Box = $('#container').data('handle');
                    mainProperties._setId = _setId;
                    mainProperties.type = 'Toppings';
                    var cartItem = new Object();
                    cartItem.quantity =  1;
                    cartItem.id = $(this).val();
                    cartItem.properties = mainProperties;
                    cartItems.push(cartItem);
                });

                var cartData = { items: cartItems};

                  theme.genie.addItemsToCart(cartData)
                  .then(function() {
                     $('#quick-view').hide();
                     new theme.ShowSummary();
                  }.bind(this))
                  .fail(function(XMLHttpRequest) {
                     $('.qv-add-button').notify(XMLHttpRequest.responseJSON.description,{ position:"top center", className: "error" } );
                  }.bind(this))
                  .always(function() {
                    $.LoadingOverlay("hide");
                  }.bind(this));
            });
      
      
          
          
         
          
        });
    
    

     
    $('body').on('change', '.option', function() {
       $('.qv-product-price').text($(this).children("option:selected").data('price'));
    }); 
    
     $('body').on('click', '.pizza_remove', function() {
       $.LoadingOverlay("show");
       var setId = $(this).find('.item_setid').text();
       var variantId = $(this).find('.item_variant').text();
       theme.genie.getCart().then(function(cart){
       
         var variantIds = [];
         
         $(cart.items).each(function(i,item) {
           var item_type = '';
           $(item.properties).each(function(i,property) {
            if(property._setId == setId){
              variantIds.push('updates['+item.variant_id+']=0');
            }
            
          });
           
           
           
           
           
           
         });
         
         var cartData = variantIds.join('&');
      
          theme.genie.removeItemsFromCart(cartData)
            .then(function() {
               
               new theme.ShowSummary();
            }.bind(this))
            .fail(function(XMLHttpRequest) {
               $('.qv-add-button').notify(XMLHttpRequest.responseJSON.description,{ position:"top center", className: "error" } );
            }.bind(this))
            .always(function() {
              $.LoadingOverlay("hide");
            }.bind(this));
         $.LoadingOverlay("hide");
       });
       
    }); 
    
    

    
  });

  theme.config = {
    BASE_URL:''
  };


  theme.genie = {
    getProductDetail: function(url) {
      return $.getJSON(url);
    },
    getCart: function(url) {
      return $.getJSON('/cart.js');
    },
    _sendAjax: function(params) {
      return $.ajax(params)
          .then(function(data) {
            return data;
          }.bind(this))
    },
    temp: function(url) {
      return this._sendAjax({
        type: 'GET',
        url: url,
        dataType:"json",
      });
    },
    addItemsToCart: function(data) {
      return this._updateCart({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json'
      });
    },
    removeItemsFromCart: function(data) {
      return this._updateCart({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json'
      });
    },
    _updateCart: function(params) {
      return $.ajax(params)
          .then(function(cart) {
            return cart;
          }.bind(this))
    },
    showError: function(el,message){
      el.append('<div class="errors text-center">'+message+'</div>');
      setTimeout(function(){
        el.find('.errors').remove();
      }, 3000);
    },
    getUrlParams:function(){
      var vars = [], hash;
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for(var i = 0; i < hashes.length; i++)
      {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
      }
      return vars;
    },
    setCookie: function(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie: function(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    getToppings: function(cart,setId) {
         var toppings= '';
         $(cart.items).each(function(i,item) {
           var item_type = '';
           $(item.properties).each(function(i,property) {
            if(property.type == 'Toppings' && property._setId == setId){
              item_type = property.type;
            }
            
          });
           
           if(item_type == 'Toppings'){
            var price = item.price /100;
            toppings+= '<p><span class="topping_title">'+item.product_title+'</span> <span class="topping_price"> 1 x '+'£'+price.toFixed(2)+'</span></p>';
           }
           
           
         });
         return toppings;
       },
    getPizzaCount: function(cart,handle) {
         var price= 0;
         $(cart.items).each(function(i,item) {
           var item_type = '';
           $(item.properties).each(function(i,property) {
            if(property.type == 'Cold Pizza' && property.Box == handle){
              price = price + 1;
            }
            
          });
           
           
           
         });
         return price;
       },
        checkForHotPizza: function(cart) {
          var hotPizzaStatus= 0;
          $(cart.items).each(function(i,item) {
            //console.log(item);
            if(item.product_type == "Hot Pizza"){
              hotPizzaStatus = 1;
            }



          });
          return hotPizzaStatus;
        },
    getToppingsPrice: function(cart,setId) {
         var totalprice = 0;
         $(cart.items).each(function(i,item) {
           var item_type = '';
           $(item.properties).each(function(i,property) {
            if(property.type == 'Toppings' && property._setId == setId){
              item_type = property.type;
            }
            
          });
           
           if(item_type == 'Toppings'){
            var price = item.price /100;
            totalprice = totalprice + price ;
           }
           
           
         });
         return totalprice;
       }

  }
  
  theme.ShowSummary = (function() {
    var config = {
      namespace: '.swapmodal'
    };

    var selectors = {
      container: '#swapModalContent',
      template: '#SwapModalTemplate',
      btn: '#ApplySwap--Bundle'
    };

    function ShowSummary() {
     
      theme.genie.getCart().then(this.displayValues.bind(this));
      
      
      this.initEventListeners();

    };
    
     ShowSummary.prototype = $.extend({}, ShowSummary.prototype, {
      initEventListeners: function() {
     
        
      },
       displayValues: function(cart) {
         var total_price = 0;
        $('#items_summary .cart-list').html('');
        $(cart.items).each(function(i,item) {
          $('.item_summary .extra_toppings').html('');
          var item_type = '';
          var item_setid = '';
          $(item.properties).each(function(i,property) {
            if(property.type == 'Cold Pizza'){
              item_type = property.type;
                item_setid = property._setId;
            }
            
          });
          
          
          if(item_type == 'Cold Pizza'){
            $('.item_summary .pizza_title').text(item.product_title);
            var price = item.price /100;
            total_price = total_price + price;
            total_price = total_price + theme.genie.getToppingsPrice(cart,item_setid);
            $('.item_summary .pizza_price').text('1 x '+'£'+price.toFixed(2));
            $('.item_summary .extra_toppings').html(theme.genie.getToppings(cart,item_setid));
            $('.item_summary .item_setid').text(item_setid);
            $('.item_summary .item_variant').text(item.variant_id);
            $('#items_summary .cart-list').append('<li class="cart-list__item">'+$('.item_summary').html()+'</li>');
          }
          
        });
         
         $('.summary_total').text('£'+total_price.toFixed(2));
         $('#itemsListContent').html($('#items_summary').html());
         //console.log(total_price);
         
      },
       
       

      
    });

    return ShowSummary;
  })();

  
  


})(jQuery)